import Dropdown, { Placement } from "../Dropdown";
import React, { useState } from "react";
import styles from "./MoreOperationButton.module.scss";
import SvgButton from "../svg-button";
import {
  MoreSvg,
  RemoveSvg,
} from "@/assets/icons";
import { useTranslation } from "react-i18next";
import Tooltip from "../tooltip";
import Analyse from "@/utils/analyse";
import { CollectStatus, PageType } from "@/constants";
import { toast } from "react-toastify";
import clsx from "clsx";
import useEffectStore from "@/stores/effectStore";

export default function MoreOperationButton(props: {
  onOpenChange?: (show: boolean) => void;
}) {
  const { t } = useTranslation();
  return (
    <Dropdown
      zIndex={5000}
      placement={Placement.bottomRight}
      className={styles.modal}
      popContent={<MoreEditMenu />}
      onOpenChange={(show) => {
        if (show) {
          Analyse.getInstance().featureClick("more_operation");
        }
        props.onOpenChange?.(show);
      }}
    >
      <SvgButton>
        <Tooltip
          content={t("more_tip")}
          placement="top"
        ></Tooltip>
        <MoreSvg />
      </SvgButton>
    </Dropdown>
  );
}

export const MoreEditMenu = () => {
  const { t } = useTranslation();
  // const task = useCommonStore((state) => state.task);
  const [collectStatus, setCollectStatus] = useState<CollectStatus>(
    CollectStatus.UnCollect
  );
  const [collectLoading, setCollectLoading] = useState(false);

  // const clearTemp = useCommonStore((state) => state.clearActiveTemp);
  // const clearActiveTemp = useCommonStore((state) => state.clearActiveTemp);
  // const setPageType = useCommonStore((state) => state.setPageType);
  // const clearSwapTemp = useCommonStore((state) => state.clearSwapTemp);
  // const clearTask = useCommonStore((state) => state.clearTask);
  // const handleCollect = () => {
  //   if (!task) return;
  //   if (!task.taskId) return;
  //   setCollectLoading(true);
  //   Analyse.getInstance().featureClick(
  //     collectStatus === CollectStatus.Collected ? "unfavorite" : "favorite"
  //   );
  //   const finalCollectStatus =
  //     collectStatus === CollectStatus.Collected
  //       ? CollectStatus.UnCollect
  //       : CollectStatus.Collected;

  //   postCollect({
  //     taskIds: task!.taskId,
  //     collection: finalCollectStatus,
  //   })
  //     .then((res) => {
  //       const { code, msg } = res;
  //       if (code === APICode.Success) {
  //         setCollectStatus(finalCollectStatus);

  //         toast(
  //           collectStatus === CollectStatus.Collected
  //             ? t("uncollect_success")
  //             : `👌 ${t("collect_success")}`
  //         );
  //       } else {
  //         console.error(new Error(msg));
  //       }
  //     })
  //     .catch(console.error)
  //     .finally(() => {
  //       setCollectLoading(false);
  //     });
  // };
  const handleDelete = () => {
    // if (task) {
    //   // Analyse.getInstance().featureClick("delete");
    //   // deleteAigcTask(task.taskId).then((res) => {
    //   //   if (res.code === "000") {
    //   //     toast(t("delete_success"));
    //   //     // clearTemp();
    //   //     // clearActiveTemp();
    //   //     // clearSwapTemp();
    //   //     clearTask();
    //   //     setPageType(PageType.Create);
    //   //   } else {
    //   //     toast(t("delete_fail"));
    //   //   }
    //   // });

    //   useEffectStore.getState().setPageType(PageType.Create);
    // }
    Analyse.getInstance().featureClick("delete");
    useEffectStore.getState().setPageType(PageType.Ready);
    useEffectStore.getState().clearData();
  };

  const isFavorite = collectStatus === CollectStatus.Collected;

  return (
    <ul className={styles.menus}>
      {/* <li className={styles.menu} onClick={handleCollect}>
        <span className={clsx(styles.icon, isFavorite && styles.collected)}>
          {isFavorite ? (
            <CollectedSvg></CollectedSvg>
          ) : (
            <CollectSvg></CollectSvg>
          )}
        </span>
        <span className={styles.text}>
          {isFavorite ? t("uncollect-tip") : t("collect-tip")}
        </span>
      </li> */}

      <li className={styles.menu} onClick={handleDelete}>
        <span className={styles.icon}>
          <RemoveSvg />
        </span>
        <span className={styles.text}>{t("delete")}</span>
      </li>
    </ul>
  );
};
